import React, { useEffect, useState } from "react";
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { FaRegFilePdf } from "react-icons/fa6";
import Dashboard from "./Dashboard";
import '../css/bitacora.css'
import Logo from '../Images/logo.jpg'
import Fondo from '../Images/fondoPDF.jpg'
import axios from "axios";

const url = process.env.REACT_APP_URL;
const urlImg = process.env.REACT_APP_IMG;

const Bitacora = ({ user, setUser }) => {

    const [errorFecha, setErrorFecha] = useState(false);
    const [espera, setEspera] = useState(false);

    const [fechaSelecionada, setFechaSelecionada] = useState({
        dia: ''
    })

    const [datosObra, setDatosObra] = useState()

    useEffect(() => {
        getDastosGeneralesObra()
    })

    const inputChange = ({ target }) => {
        const { name, value } = target
        setFechaSelecionada({
            ...fechaSelecionada,
            [name]: value
        })
    }

    const getDastosGeneralesObra = async () => {
        const response = await axios.get(url + 'obra/datosgenerales/' + user.idObra)
        setDatosObra(response.data)
    }

    const mostrar = async (e) => {
        e.preventDefault()

        setEspera(true);
        setTimeout(() => setEspera(false), 3000);

        const response = await axios.get(url + 'bitacora/' + user.idObra + '/' + fechaSelecionada.dia)
        const doc = new jsPDF({ format: "letter" });

        const nombreCliente = user.nombreCliente + " " + user.apellidoPCliente + " " + user.apellidoMCliente;
        const repreLegal = "ING. ROSALIO SUASTEGUI MOLINA";
        const repreObra = datosObra.nombreEmp + " " + datosObra.apellidoPaternoEmp + " " + datosObra.apellidoMaternoEmp;
        const nombreObra = datosObra.nombreObra;
        const ubicacionObra = datosObra.direccionObra;

        const imagenes = [];
        const comentarios = [];

        function plantilla() {
            doc.addImage(Fondo, "JPE", 0, 50, 200, 200);
            doc.setFontSize(20);
            doc.setTextColor(19, 43, 76);
            doc.setFont("times", "blod");
            doc.text("Bitacora de Obra", 80, 20);
            doc.setLineWidth(1.5);
            doc.line(10, 23, 200, 23);
            doc.addImage(Logo, "JPEG", 14, 24, 25, 25);
            doc.setFontSize(15);
            doc.text("Obra: ", 45, 30);
            doc.text(nombreObra, 60, 30);
            doc.text("Ubicación: ", 45, 35);
            doc.text(ubicacionObra, 70, 35);
            doc.text("Ciudad: Chilpancingo", 45, 40);
            doc.text("Estado: Guerrero", 45, 45);
            doc.setFontSize(10);
            doc.text("Fecha: ", 165, 45);
            doc.text(fecha(), 180, 45)
            doc.setLineWidth(1);
            doc.line(10, 50, 200, 50);

            const columns2 = ["Elaboro", "Vo. Bo.:", ""]
            const data2 = [
                ["ROSMO COIN S.A. DE C.V.", "", ""],
                ["\r", "\r", "\r"],
                [repreLegal + "\rREPRESENTANTE LEGAL", repreObra.toUpperCase() + "\rREPRESENTANTE DE OBRA", nombreCliente.toUpperCase() + "\rDUEÑO DE OBRA"],
            ]

            doc.autoTable({
                theme: 'plain',
                styles: {
                    font: 'times',
                    fontSize: 10,
                    halign: 'center'
                },
                headStyles: {
                    fontSize: 11,
                    cellWidth: 65
                },
                startY: 222,
                head: [columns2],
                body: data2
            });

            //linea para firma
            doc.setLineWidth(0.5);
            doc.line(15, 250, 78, 250);
            doc.line(83, 250, 142, 250);
            doc.line(148, 250, 205, 250);

            doc.line(14, 222, 14, 265);
            doc.line(80, 222, 80, 265);
            doc.line(145, 222, 145, 265);
            doc.line(210, 222, 210, 265);

            //lineas horizontales pie de pagina
            doc.line(14, 222, 210, 222);
            doc.line(14, 265, 210, 265);
        }

        if (response.data.length <= 0) {
            setErrorFecha(true);
            setTimeout(() => setErrorFecha(false), 5000);
        } else {
            for (let i = 0; i < response.data.length; i++) {
                imagenes.push(urlImg + response.data[i].nombreImg);
                if (response.data[i].comentario.length > 30) {
                    let text = response.data[i].comentario;
                    let caractater = text.charAt(29);
                    let salto = "\r"
                    if (caractater === " ") {
                        let nuevoComent = text.slice(0, 29) + salto + text.slice(29)
                        comentarios.push(nuevoComent);
                    }
                    if (/[a-zA-Z]/.test(caractater)) {
                        let nuevoComent = text.slice(0, 28) + salto + text.slice(28)
                        comentarios.push(nuevoComent);
                    }
                } else {
                    comentarios.push(response.data[i].comentario);
                }
                //console.log(urlImg + response.data[i].nombreImg);
            }

            const agregarGrupoDeImagenesAPagina = (grupo) => {
                grupo.forEach((imagen, index) => {
                    const x = (index % 2) * 100 + 15;
                    const y = Math.floor(index / 2) * 80 + 59;
                    doc.addImage(imagen, 'JPEG', x, y, 85, 65);
                });
            };         

            const agregarGrupoDeComentariosAPagina = (grupo) => {
                grupo.forEach((comentario, index) => {
                    const x = (index % 2) * 100 + 15;
                    const y = Math.floor(index / 2) * 80 + 130;
                    doc.text(comentario, x, y,);
                });
            };

            for (let i = 0; i < imagenes.length; i += 4) {
                plantilla();
                const grupo = imagenes.slice(i, i + 4);
                const grupo2 = comentarios.slice(i, i + 4);
                agregarGrupoDeImagenesAPagina(grupo);
                agregarGrupoDeComentariosAPagina(grupo2);
                if (i + 4 < imagenes.length) {
                    doc.addPage();
                }
            }

            doc.output('dataurlnewwindow', {
                filename: 'bitacora.pdf'
            })
        }
        setFechaSelecionada({ ...fechaSelecionada, dia: '' })
    }

    function fecha() {
        const date = new Date();

        const dia = date.getDate()
        const mes = date.getMonth()
        const anio = date.getFullYear()

        const fecha = dia + "/" + (mes + 1) + "/" + anio

        return fecha
    }

    return (
        <div>
            <Dashboard user={user} setUser={setUser} />
            <div className="content">
                <form onSubmit={mostrar}>
                    <h3>Seleccione la fecha que desea</h3>
                    <input
                        type="date"
                        id="fecha"
                        name="dia"
                        value={fechaSelecionada.dia}
                        onChange={inputChange}
                        required
                    />
                    <button
                        className="btn btn-danger"
                        type="submit">
                        <FaRegFilePdf /> Generar
                    </button>
                    {
                        errorFecha &&
                        <div className="alert alert-danger">
                            Error... no hay datos registrados para está fecha
                        </div>
                    }
                    {
                        espera &&
                        <div className="alert alert-info">
                            La petición está siendo procesada... Por favor espere...
                        </div>
                    }
                </form>
            </div>
        </div>
    )
}

export default Bitacora